import * as React from 'react';
import { useLocation } from 'react-router';

import appUrls from 'base/app/urls';
import { Habits } from 'base/api/types';
import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  StatusFilter,
  SearchInput,
  ContentRow,
} from 'templates/content';
import { ContentRowProps } from 'templates/content/components/ContentRow';
import { DetailsSwitch } from 'templates/details';
import { translate as t } from 'common/utils/translate';

import HabitsDetails from './HabitsDetails';
import { useHabitsList } from '../queries';

const fields = {
  search: 'search',
  filter: 'filter',
  sort: 'sort',
};

const HabitsList = () => {
  const location = useLocation();
  const { data, isError } = useHabitsList();
  const context = {
    data: data?.values,
    path: {
      details: appUrls.HABITS.DETAILS,
      list: appUrls.HABITS.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title={t("Habit's")}>
          <FiltersForm
            sort={['description', fields.sort]}
            search={['description', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError}>{HabitsContentRow}</ContentList>
        <DetailsSwitch>
          <HabitsDetails key={location.pathname} />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

const HabitsContentRow = (props: ContentRowProps<Habits>) => {
  return <ContentRow {...props} data={props.data} />;
};
export default HabitsList;
